import {environment} from '../../../environments/environment';

export const baseUrl = environment.hostname ?
  (environment.port ?
    `${environment.hostname}:${environment.port}/api` :
    `${environment.hostname}/api`) :
  '/api';
